import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { loadTelegramSdk, prepareViewport } from './auth/telegram'
import './theme.css'

/**
 * Запуск приложения.
 *
 * SDK Telegram ждём ТОЛЬКО внутри Telegram и только ограниченное время: без
 * `initData` вход в Mini App не построить, поэтому там подождать правильно.
 * Вне Telegram `loadTelegramSdk` отвечает отказом сразу и в сеть не ходит —
 * веб-версия обязана подниматься, даже когда telegram.org недоступен.
 *
 * Раньше SDK стоял тегом в разметке, и его молчание означало чёрный экран:
 * отложенные скрипты выполняются по порядку, и сборка ждала его вечно.
 */
async function boot(): Promise<void> {
  await loadTelegramSdk()

  // Окно Telegram готовим до первого кадра: развернуть на весь экран и
  // запретить вертикальный свайп, который иначе закрывает вебвью посреди
  // записи подхода (раздел 13). Вне Telegram вызов ничего не делает.
  prepareViewport()

  const container = document.getElementById('root')
  if (!container) throw new Error('Не найден корневой элемент')

  createRoot(container).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
}

void boot()

// Service worker регистрируем только в продакшене: в разработке он кеширует
// старую сборку и заставляет гадать, почему правка не видна.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // PWA — это удобство, а не условие работы. Не зарегистрировался —
      // приложение работает как обычная страница.
    })
  })
}
